import { render, staticRenderFns } from "./EmployeePermissionTableForm.vue?vue&type=template&id=20f270f4&"
import script from "./EmployeePermissionTableForm.vue?vue&type=script&lang=js&"
export * from "./EmployeePermissionTableForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePermissionTableForm.vue?vue&type=style&index=0&id=20f270f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports